import { faro } from '@grafana/faro-core';
export function isWebStorageAvailable(type) {
    var _a;
    try {
        let storage;
        storage = window[type];
        const testItem = '__faro_storage_test__';
        storage.setItem(testItem, testItem);
        storage.removeItem(testItem);
        return true;
    }
    catch (error) {
        // the above can throw
        (_a = faro.internalLogger) === null || _a === void 0 ? void 0 : _a.info(`Web storage of type ${type} is not available. Reason: ${error}`);
        return false;
    }
}
export const isLocalStorageAvailable = isWebStorageAvailable('localStorage');
export function getItem(key) {
    if (isLocalStorageAvailable) {
        return localStorage.getItem(key);
    }
    return null;
}
export function setItem(key, value) {
    if (isLocalStorageAvailable) {
        try {
            localStorage.setItem(key, value);
        }
        catch (error) {
            // do nothing
        }
    }
}
export function removeItem(key) {
    if (isLocalStorageAvailable) {
        localStorage.removeItem(key);
    }
}
//# sourceMappingURL=webStorage.js.map